

export function decodeJwt(message) {
    const jwtRx = /^([0-9a-z_-]+)\.([0-9a-z_-]+)\.([0-9a-z_-]+)$/i;
    if (isString(message)) {
        let jwt;
        if ((jwt = jwtRx.exec(message))) {
            if (jwt.length !== 4) {
                throw new Error("wrong JWS compact serialization format");
            }
            let payload =  JSON.parse(decode(jwt[2]));
            payload.adminRole = adminRole(payload);
            payload.userRole = userRole(payload);
            return payload;
        } else {
            throw new Error("wrong JWS compact serialization format");
        }
    } else {
        throw new Error("data format not supported");
    }
}

const isString = (str) => {
    return ((typeof(str) === "string") || (str instanceof String));
};

const decode = (str) => b64DecodeUnicode(str.replace(/-/g, "+").replace(/_/g, "/"));

const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = '0' + code;
        }
        return '%' + code;
    }));
};

function adminRole(jwt){
    return checkRole(jwt, "ROLE_ADMIN")
}

function userRole(jwt){
    return checkRole(jwt, "ROLE_USER")
}

function checkRole(jwt, role){
    if (isString(jwt)) {
        jwt = decodeJwt(jwt);
    }
    if(jwt.payload){
        jwt = jwt.payload;
    }
    let haveRole = false;
    if (jwt.roles) {
        jwt.roles.split(/,/).forEach(r => {
            if (r === role) {
                haveRole = true;
            }
        })
    }
    return haveRole;
}
